module.exports = __webpack_public_path__ + "static/media/man-bike.15258d57.jpg";